import React from "react";
import Cta from "@qlik/qlik/src/components/Cta";
import Media from "@qlik/qlik/src/components/Media";
import { getSpacingClassName } from "@qlik/qlik/src/lib/util/spacing";
import { getCardBodyContent, renderSanitizedHtmlContent } from "@qlik/qlik/src/lib/util/helpers";
import * as styles from "./styles.module.css";

/**
 * HeroBannerNoImage component.
 * Renders a section with a title, description, CTA, and media.
 * @param {Object} data - The data for the component.
 * @param {Object} data.cardItem - The card item data.
 */
const HeroBannerNoImageV2 = ({ data }) => {
    const { cardItem, additionalConfiguration, backgroundImage, customId } = data || {};
    const { title, eyebrowText, cta } = cardItem || {};

    const bodyContent = getCardBodyContent(data?.cardItem);
    const mediaAssetExist = backgroundImage?.length > 0;
    const spacingClassNames = getSpacingClassName(additionalConfiguration, "pt-10 pb-2.5 lg:pb-5 xl:py-0");

    return (
        <section className={`overflow-hidden ${spacingClassNames}`} id={customId}>
            <div className={`container `}>
                <div className="row relative">
                    <div className={` w-full lg:w-[800px] xl:pr-0 xl:pb-25 xl:pt-20 self-center`}>
                        {eyebrowText && (
                            <p className="text-base font-medium tracking-wide5 leading-tight mb-3 text-ocean">
                                {eyebrowText}
                            </p>
                        )}
                        <h1
                            className={`text-with-color text-with-ceil ${styles.banner}`}
                            // eslint-disable-next-line react/no-danger
                            dangerouslySetInnerHTML={{ __html: renderSanitizedHtmlContent(title) }}
                        />
                        {bodyContent && <div className={styles.description}>{bodyContent}</div>}
                        {cta?.length > 0 && (
                            <div className="sm:mt-5 flex flex-wrap gap-x-5 lg:mt-7.5">
                                {cta?.map((button) => (
                                    <Cta key={button.id} data={button} className="mt-5" />
                                ))}
                            </div>
                        )}
                    </div>
                    {mediaAssetExist && (
                        <div className="absolute hidden xl:block max-w-none max-h-none -z-1 lg:w-142.5 lg:-right-70  xl:w-[1010px] xl:h-[388px] xl:-right-155 xl:-top-3 xl:px-0">
                            {backgroundImage?.[0] && (
                                <Media
                                    className="max-w-none max-h-none lg:w-142.5 xl:w-[1010px] xl:h-[388px]"
                                    link={backgroundImage?.[0]?.secure_url}
                                />
                            )}
                        </div>
                    )}
                </div>
            </div>
        </section>
    );
};

export default HeroBannerNoImageV2;
